import axios from "axios";
import { MessageBox, Message, Loading } from "element-ui";
import store from "@/store";
import { getToken } from "@/utils/auth";
import qs from "qs";


var pendingRequest = new Map();
// 生成request的唯一key
var generateRequestKey = (config = {}) => {
  // 通过url，method，params，data生成唯一key，用于判断是否重复请求
  // params为get请求参数，data为post请求参数
  const { url, method, params, data } = config;
  return [url, method, params, data].join("&");

  // return [method, url, qs.stringify(params), qs.stringify(data)].join('&');
};

// 将重复请求添加到pendingRequest中
var addPendingRequest = (config) => {
  const key = generateRequestKey(config);
  if (!pendingRequest.has(key)) {
    config.cancelToken = new axios.CancelToken((cancel) => {
      pendingRequest.set(key, cancel);
    });
  }
};

// 取消重复请求
var removePendingRequest = (config) => {
  const key = generateRequestKey(config);
  const cancelToken = pendingRequest.get(key);
  if (cancelToken) {
    // const cancelToken = pendingRequest.get(key);
    cancelToken(key); // 取消之前发送的请求
    pendingRequest.delete(key); // 请求对象中删除requestKey
  }
};
const service = axios.create({
  // baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // baseURL: "https://zyzzos.xingshu.tech/admin", // 开发地址
  // baseURL: 'https://szyq.zzkgjt.cn:8443/admin', //打包地址
  // baseURL: "https://wxxcx.zzkgjt.cn:8443/admin", //测试服务器地址
  // withCredentials: true, // send cookies when cross-domain requests
  // timeout: 5000 // request timeout
  // baseURL: 'https://wx.hz-cdwy.cn:4433/admin'
});
// request interceptor
service.interceptors.request.use(
  (config) => {
    //  config.baseURL = '/api'
    config.baseURL = store.state.baseURL
    new Promise(() => {
      // 处理重复请求
      removePendingRequest(config);
      // pendingRequest.clear()
      addPendingRequest(config);
    });
    // do something before request is sent
    if (store.getters.token) {
      config.headers["token"] = getToken();
      config.headers["Content-Type"] = config.ContentType
        ? config.ContentType
        : "application/x-www-form-urlencoded";
    }
    return config;
  },
  (error) => {
    pendingRequest.clear();
    // do something with request error
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  (response) => {
    new Promise(() => {
      // 移除重复请求
      // pendingRequest.clear()
      removePendingRequest(response.config);
    });
    const res = response.data;
    const indexs = response.config.responseType;
    if (indexs === "arraybuffer") {
      return Promise.resolve(
        "data:image/png;base64," +
          window.btoa(
            new Uint8Array(res).reduce(
              (data, byte) => data + String.fromCharCode(byte),
              ""
            )
          )
      );
    }
    if (indexs === "blob") {
      let fileName = decodeURI(response.headers["content-disposition"]).replace(
        /attachment;filename=/,
        ""
      );

      return { data: res, name: fileName };
      // return  res
    }
    // if the custom code is not 20000, it is judged as an error.
    if (res.code !== 200 && res.code !== 1100) {
      // 300:token失效; 50012:其他客户端登录了;  50014:Token 过期了;
      if (res.code === 300 || res.code === 50012 || res.code === 50014) {
        // to re-login
        MessageBox.confirm(
          "你已被登出，可以取消继续留在该页面，或者重新登录",
          "确定登出",
          {
            confirmButtonText: "重新登录",
            cancelButtonText: "取消",
            type: "warning",
          }
        ).then(() => {
          // store.dispatch('user/resetToken').then(() => {
          //   location.reload()
          // })
          window.localStorage.clear();
          // 状态保持清除后刷新页面
          window.location.reload();
          this.$router.push(`/login`);
        });
        return res
      }
      Message({
        message: res.msg || "Error",
        type: "error",
        duration: 3 * 1000,
        customClass: "myAge",
      });
      return res;
    } else {
      return res;
    }
  },
  (error) => {
    // MessageBox.confirm(
    //   "你已被登出，可以取消继续留在该页面，或者重新登录",
    //   "确定登出",
    //   {
    //     confirmButtonText: "重新登录",
    //     cancelButtonText: "取消",
    //     type: "warning",
    //   }
    // ).then(() => {
    //   // store.dispatch('user/resetToken').then(() => {
    //   //   location.reload()
    //   // })
    //   window.localStorage.clear();
    //   // 状态保持清除后刷新页面
    //   window.location.reload();
    //   this.$router.push(`/login`);
    // });

    // Message({
    //   message: error.msg,
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    removePendingRequest(error.config || {});
    return Promise.reject(error);
  }
);

export default service;
